/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDriveable32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 12.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM13.75 16a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 3.25C8.958 3.25 3.25 8.958 3.25 16S8.958 28.75 16 28.75 28.75 23.042 28.75 16 23.042 3.25 16 3.25zM4.75 16c0-.54.038-1.07.111-1.59l5.697-2.513a13.483 13.483 0 0110.884 0l5.697 2.513a11.339 11.339 0 01.108 1.854c-5.523.064-9.997 4.563-9.997 10.12v.797a11.366 11.366 0 01-2.5 0v-.798c0-5.556-4.474-10.055-9.997-10.119A11.45 11.45 0 014.75 16zm5.203-5.475l-4.676 2.063C6.722 8.043 10.977 4.75 16 4.75c5.023 0 9.278 3.293 10.723 7.838l-4.675-2.063a14.982 14.982 0 00-12.095 0zm8.797 15.858a8.62 8.62 0 018.362-8.616 11.263 11.263 0 01-8.362 9.144v-.528zm-5.5 0v.528a11.263 11.263 0 01-8.362-9.144 8.62 8.62 0 018.362 8.616z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 .25C7.302.25.25 7.301.25 16c0 8.698 7.052 15.75 15.75 15.75S31.75 24.698 31.75 16C31.75 7.301 24.698.25 16 .25zM1.75 16C1.75 8.13 8.13 1.75 16 1.75S30.25 8.13 30.25 16 23.87 30.25 16 30.25 1.75 23.87 1.75 16z'
      />
    </svg>
  );
}

export default SvgDriveable32;
